import { createContext, useContext } from "react";

export const VisitDialogContext = createContext();
export const useVisitDialog = () => {
    const context = useContext(VisitDialogContext)
    if(!context) {
        throw new Error("useVisitDialog must be used inside VisitDialog")
    }
    return context;
}